/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { BackpackThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import { EmailInput, UrlInput, TextInputWithMargin } from 'components/common/TextInput';
import { Button } from 'components/common/Button';
import Form from 'components/common/Form';
import FlexRow from 'components/common/FlexRow';

import './GroupSetup.styles.css';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';
import { PrivacyLink, TermsLink, CookiePolicyLink } from 'components/pages/other/Policy';

const GroupSetupView = (props) => {
  return (
    <BackpackThemedContentPanelWithFullHeader
      isFixedWidth
      titlePhrase={{ id: 'groupSetup.title.text' }}
      subTitle={<FormattedMessage id="app.name" />}
    >
      <WhiteCardWithWidePadding>
        <Form>
          <TextInputWithMargin
            value={props.organizationName}
            onChange={(e) => props.onChangeOrganizationName(e.target.value)}
            type="text"
            label={<FormattedMessage id="groupsetup.orgName.field.label" />}
            hint={<FormattedMessage id="groupsetup.orgName.field.hint" />}
            name="group_organization_name"
            initialFocus={!props.hasInitialData}
          />

          <TextInputWithMargin
            value={props.name}
            onChange={(e) => props.onChangeName(e.target.value)}
            onFocus={props.onStartChangeName}
            onBlur={props.onFinishChangeName}
            type="text"
            label={<FormattedMessage id="groupSetup.groupName.field.label" />}
            hint={<FormattedMessage id="groupSetup.groupName.field.hint" />}
            name="group_name"
          />

          <UrlInput
            value={props.subdomain}
            onChange={props.onChangeUrl}
            label={<FormattedMessage id="groupSetup.groupURL.field.label" />}
            hint={<FormattedMessage id="groupSetup.groupURL.field.hint" />}
            urlSuffix={<FormattedMessage id="groups.baseURL.name.text" />}
            name="group_url"
          />

          <EmailInput
            value={props.email}
            onChange={(value) => props.onChangeEmail(value)}
            label={<FormattedMessage id="groupSetup.ownerEmail.field.label" />}
            hint={<FormattedMessage id="groupSetup.ownerEmail.field.hint" />}
            name="owner_email"
          />

          <section>
            <div className="font-footnote font-color-gsMiddle">
              <FormattedMessage id="groupSetup.termsPrivacy.message.text" />
            </div>
            <div>
              <PrivacyLink className="font-footnote theme-group base color" />
            </div>
            <div>
              <TermsLink className="font-footnote theme-group base color" />
            </div>
            <div>
              <CookiePolicyLink className="font-footnote theme-group base color" />
            </div>
          </section>

          <section>
          <FlexRow>
            <div />
            <Button
              className="theme-group base background"
              onClick={props.onSubmitForm}
              isDisabled={props.isSubmitDisabled}
            >
              <FormattedMessage id="groupSetup.createGroup.button.label" />
            </Button>
          </FlexRow>
          </section>
        </Form>
      </WhiteCardWithWidePadding>
    </BackpackThemedContentPanelWithFullHeader>
  );
}

export default GroupSetupView;